export default __webpack_public_path__ + "static/media/grayFullTank.0d44c402.svg";